var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellRinging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 31,
    viewBox: "0 0 29 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2507 30.0837C11.1901 30.0837 8.70898 27.6026 8.70898 24.542H19.7923C19.7923 27.6026 17.3112 30.0837 14.2507 30.0837Z",
    fill: "#405065"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6993 24.5417H2.80071C1.25392 24.5417 0 23.2877 0 21.741C0 20.9982 0.295074 20.2858 0.82031 19.7606L1.77542 18.8054C2.66622 17.9146 3.16667 16.7065 3.16667 15.4467V11.0833C3.16667 4.96218 8.12884 0 14.25 0C20.3712 0 25.3333 4.96217 25.3333 11.0833V15.4467C25.3333 16.7065 25.8338 17.9146 26.7246 18.8054L27.6797 19.7605C28.2049 20.2858 28.5 20.9982 28.5 21.741C28.5 23.2877 27.2461 24.5417 25.6993 24.5417Z",
    fill: "#163358"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellRinging);
export default __webpack_public_path__ + "static/media/bell-ringing.2fe7cf2a671530b2600a7a413a4e766a.svg";
export { ForwardRef as ReactComponent };